export default "__VITE_ASSET__C0bAM2dL__"